export const it = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Indietro",
        save: "Salva",
        saved: "Salvato",
        cancel: "Annulla",
        close: "Chiudi",
        accessDenied: "Accesso Negato",
        noExportPermission: "Non hai il permesso di esportare i dati di questa auto.",
        delete: "Elimina",
        downgrade: "Downgrade",
        downgradeConfirm: "Sei sicuro di voler passare al piano gratuito?",
        edit: "Modifica",
        loading: "Caricamento...",
        confirm: "Conferma",
        processing: "Elaborazione...",
        history: "Cronologia",
        currentCar: "Auto Corrente",
        purchasedCarTitle: "Acquisto Auto",
        initialCost: "Costo Iniziale",
        done: "Fatto",
        ok: "OK",
        error: "Errore",
        errorSaving: "Errore nel salvataggio dei dati",
        mandatoryFieldsError: "Si prega di compilare correttamente tutti i campi obbligatori.",
        search: "Cerca",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Formato email non valido",
        today: "Oggi",
        car: "Auto",
        all: "Tutti",
        deleteConfirm: "Elimina",
        unsavedChangesTitle: "Modifiche Non Salvate",
        unsavedChangesMessage: "Vuoi salvare le modifiche prima di uscire?",
        dontSave: "Non Salvare",
        additionalOptions: "Opzioni aggiuntive",
        add: "Aggiungi",
        fileTooLarge: "Il file è troppo grande. La dimensione massima è {limit} MB.",
        storageFull: "Limite di archiviazione superato. La capacità massima è {limit} MB.",
        dailyUploadLimit: "Limite di caricamento giornaliero raggiunto ({limit} file/giorno). Riprova domani.",
        hourlyUploadLimit: "Limite di caricamento orario raggiunto ({limit} file/ora). Riprova tra un'ora.",
        fileCountLimit: "Massimo {limit} file consentiti per elemento.",
        emailParseLimitReached: "Limite di parsing email raggiunto. Si prega di aggiornare il piano o elaborare manualmente.",
        emailLimitText: "Limite di elaborazione email raggiunto.",
        monthlyEmailScans: "Scansioni Email Mensili",
        lifetimeEmailScans: "Scansioni Email a Vita",
        monthlyFileScans: "Scansioni Ricevute Mensili",
        lifetimeFileScans: "Scansioni Ricevute a Vita",
        fileLimitText: "Limite di scansione ricevute raggiunto.",
        planFreeTier: "Piano Gratuito",
        planProTier: "Piano Pro",
        uploadFailed: "Caricamento fallito",
        attachments: "Allegati",
        limitsAndUsage: "Limiti e Utilizzo",
        addresses: "indirizzi",
        emailCopied: "Indirizzo email copiato!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Incluso",
        proOnly: "Solo PRO",
        month: "mese",
        openInNewTab: "Apri in una nuova scheda",
        menu: "Menu",
        home: "Home",
        monthsShort: {
            0: "Gen",
            1: "Feb",
            2: "Mar",
            3: "Apr",
            4: "Mag",
            5: "Giu",
            6: "Lug",
            7: "Ago",
            8: "Set",
            9: "Ott",
            10: "Nov",
            11: "Dic",
        },
    },
    carMetadata: {
        bodyType: "Tipo di Carrozzeria",
        drivetrain: "Trasmissione",
        transmission: "Cambio",
        bodyTypes: {
            sedan: "Berlina",
            hatchback: "Hatchback",
            wagon: "Station Wagon",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupé",
            convertible: "Cabriolet",
            pickup: "Pickup",
            van: "Furgone / Monovolume",
            commercial: "Commerciale",
            other: "Altro",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Altro",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manuale",
            automatic: "Automatico",
            cvt: "CVT",
            other: "Altro",
        },
        otherLabel: "Altro (specificare)",
        mileageLabel: "Chilometraggio",
    },
    auth: {
        welcome: "Benvenuto",
        welcomeBack: "Bentornato",
        signIn: "Accedi",
        signInWithGoogle: "Accedi con Google",
        signOut: "Disconnetti",
        magicLinkDesc: "Ricevi un link magico nella tua email",
        magicLinkSent: "Link magico inviato!",
        magicLinkCheckEmail: "Controlla la tua email e clicca sul link per accedere.",
        emailAddress: "Indirizzo Email",
        getMagicLink: "Ottieni Link Magico",
        sending: "Invio...",
        linkSent: "Link Inviato",
        orContinueWith: "Oppure continua con",
        googleAccount: "Account Google",
        newUserNote: "Sei nuovo qui? Il tuo account sarà creato automaticamente al primo accesso riuscito.",
        magicLinkError: "Impossibile inviare il link magico. Controlla la tua email e riprova.",
        genericError: "Si è verificato un errore. Riprova.",
        projectDescription: "Tieni traccia dei costi, della manutenzione e della cronologia della tua auto in un unico posto.",
        loginError: "Impossibile accedere",
        loggingIn: "Accesso in corso...",
        authenticating: "Autenticazione in corso...",
        authenticatingDesc: "Attendere mentre proteggiamo la tua sessione.",
    },
    settings: {
        title: "Impostazioni",
        systemPreferences: "Preferenze di Sistema",
        appSettings: "Impostazioni App",
        dangerZone: "Zona Pericolosa",
        theme: "Tema",
        language: "Lingua dell'Interfaccia",
        currency: "Valuta",
        units: "Unità",
        distanceUnit: "Unità di Distanza",
        volumeUnit: "Unità di Volume",
        expenseTypes: "Tipi di Spesa",
        expenseTypesDesc: "Gestisci categorie",
        categories: "Categorie",
        exportData: "Esporta Dati",
        exportDesc: "Scarica CSV completo",
        importData: "Importa Dati",
        importDesc: "Ripristina da backup CSV",
        deleteAccount: "Elimina Account",
        deleteAccountDesc: "Rimuovi permanentemente tutti i dati",
        enableSync: "Abilita Sincronizzazione",
        enableSyncDesc: "Sincronizza dati tra dispositivi",
        account: "Account",
        accountPlan: "Piano Account",
        carsUsage: "Auto",
        carsLimitReached: "Limite auto raggiunto",
        storageSize: "Dimensione di Archiviazione",
        emailScans: "Scansioni Email",
        fileScans: "Scansioni Ricevute",
        plans: "Piani",
        currentlyPlan: "Attualmente",
        upgradePlan: "Aggiorna",
        manageSubscription: "Gestisci abbonamento",
        nextPayment: "Prossimo pagamento",
        endsOn: "Termina il",
        adminConsole: "Console Amministratore",
        systemControl: "Controllo di Sistema",
        customCategories: "Categorie e Etichette Personalizzate",
        interfaceTheme: "Tema Interfaccia",
        light: "Chiaro",
        dark: "Scuro",
        timezone: "Fuso orario",
        timezoneDesc: "Utilizzato per promemoria email programmati",
        timeFormat: "Formato orario",
        timeFormat24h: "24 ore (14:30)",
        timeFormat12h: "12 ore (2:30 PM)",
        kilometers: "chilometri (km)",
        miles: "miglia (mi)",
        liters: "litri (l)",
        gallons: "galloni (gal)",
        accountManagement: "Gestione Account",
        contactUs: "Contattaci",
        contactDesc: "Per suggerimenti, richieste di funzionalità e domande",
        logOut: "Disconnetti",
        logOutConfirmTitle: "Disconnetti",
        logOutConfirmMessage: "Sei sicuro di voler uscire dal tuo account?",
        keepAccount: "Mantieni Account",
        deleteAccountConfirmTitle: "Elimina Account",
        deleteAccountConfirmMessage: "Sei sicuro di voler eliminare permanentemente il tuo account e tutti i dati delle auto associati? Questa azione non può essere annullata.",
        deletePermanently: "Elimina Permanentemente",
        deleting: "Eliminazione in corso...",
        contactSupport: "Contatta il Supporto",
        messageSent: "Messaggio Inviato!",
        feedbackThanks: "Grazie per il tuo feedback. Apprezziamo il tuo contributo e lo esamineremo.",
        backToSettings: "Torna alle Impostazioni",
        subjectLabel: "Oggetto",
        messageLabel: "Messaggio",
        subjectPlaceholder: "Di cosa si tratta?",
        messagePlaceholder: "Raccontaci il tuo suggerimento, richiesta di funzionalità o domanda...",
        enterSubjectAlert: "Per favore inserisci un oggetto",
        enterMessageAlert: "Per favore inserisci un messaggio",
        sendFailedAlert: "Invio del messaggio fallito. Per favore riprova più tardi.",
    },
    export: {
        title: "Esporta Dati",
        generatePDF: "Genera PDF",
        carInformation: "Informazioni Auto",
        editInfo: "Modifica le informazioni qui sotto per personalizzare la tua esportazione",
        editInfoHint: "Puoi rimuovere o modificare qualsiasi campo che non desideri includere",
        filters: "Filtri",
        expenseTypes: "Tipi di Spesa",
        includeNotes: "Includi Note",
        includeImages: "Includi File",
        hideDisabled: "Nascondi Elementi Disabilitati",
        itemsCount: "{total} elementi, {selected} selezionati",
        selectAll: "Seleziona Tutto",
        deselectAll: "Deseleziona Tutto",
        expenses: "Spese",
        notes: "Note",
        spareParts: "Pezzi di Ricambio",
        images: "Immagini",
        files: "File",
        summary: "Riepilogo",
        totalExpenses: "Spese Totali",
        totalItems: "Elementi Totali",
        generatedOn: "Generato il",
        noItemsSelected: "Nessun elemento selezionato per l'esportazione",
        noItemsAvailable: "Nessun elemento disponibile per l'esportazione",
        generating: "Generazione PDF in corso...",
        downloadPDF: "Scarica PDF",
        pdfFileName: "{carName}_export_{date}.pdf",
        reportTitle: "Rapporto Spese Auto",
        exportButton: "Esporta",
        generateCSV: "Genera CSV",
        formatSelectorTitle: "Scegli formato",
        formatSelectorMsg: "Scegli il formato di esportazione",
        proFeatureExportTitle: "Funzione Pro: Esporta Dati",
        proFeatureExportDesc: "Aggiorna a PRO per esportare la cronologia della tua auto in PDF.",
        exportRestrictedPopup: "L'esportazione dei dati è disponibile solo per gli utenti Pro.",
        allTypes: "Tutti i Tipi",
        statistics: "Statistiche",
        driven: "Percorso",
        since: "Dal",
        averageCost: "Costo Medio",
        perKm: "per km",
        perMile: "per miglio",
        period: "Periodo",
        dateFrom: "Da",
        dateTo: "A",
        allTime: "Cancella filtro",
        periodHint: "Se non viene selezionato alcun periodo — vengono mostrate tutte le spese",
        noExpenses: "Nessuna spesa corrisponde ai filtri",
        expensesSection: "Spese",
        attachmentsSection: "Allegati",
        imagesCount: "{count} immagini",
        pdfsCount: "{count} PDF",
        includeParts: "Includi pezzi di ricambio",
        pageLabel: "Pagina",
    },
    expenses: {
        title: "Spese",
        newExpense: "Nuova Spesa",
        editExpense: "Modifica Spesa",
        openExpense: "Apri voce di spesa",
        details: "Dettagli Spesa",
        selectType: "Seleziona Tipo",
        selectTypePlaceholder: "Seleziona tipo di spesa...",
        shortDescriptionPlaceholder: "Breve descrizione...",
        expenseTitle: "Titolo",
        logEntryTitleLabel: "Titolo Registrazione (Facoltativo)",
        defaultTitlePlaceholder: "Titolo predefinito - {type}",
        autoTitlePlaceholder: "Sarà compilato automaticamente in base ai tipi selezionati",
        carDataTitle: "Dati dell'Auto",
        defaultTitlePrefix: "Il titolo predefinito sarà -",
        addAnother: "Aggiungi un altro tipo di spesa",
        addAnotherHint: "Se questa registrazione include più tipi di spese, puoi aggiungerli tutti qui per garantire statistiche accurate.",
        carValueDescription: "Valore di mercato stimato dell'auto in questo momento.",
        type: "Tipo",
        date: "Data",
        amount: "Importo",
        totalAmount: "Totale",
        splitCosts: "Dividere i costi?",
        combineCosts: "Combinare i costi",
        amountWork: "Lavoro",
        amountParts: "Pezzi",
        mileage: "Chilometraggio",
        carValue: "Valore dell'Auto",
        description: "Descrizione",
        detailedDescription: "Descrizione dettagliata",
        electricity: "Elettricità",
        fuelType: "Tipo di Carburante",
        fuelTypeOptions: {
            petrol: "Benzina",
            diesel: "Diesel",
            lpg: "LPG",
            electricity: "Elettricità",
        },
        carData: "Dati dell'Auto",
        images: "File",
        addImages: "Aggiungi File",
        addImagesPDFs: "Aggiungi Immagini o PDF",
        deleteExpense: "Elimina Spesa",
        deleteConfirm: "Sei sicuro di voler eliminare questa spesa?",
        saveSuccess: "Spesa salvata con successo",
        thisExpense: "Questa spesa",
        stats: {
            annual: "Annuale",
            allTime: "Tutti i Tempi",
            avgMonth: "Media/Mese",
            costPer: "Costo/",
            noExpenses: "Nessuna spesa ancora",
            dragToReorder: "Trascina per riordinare",
        },
        expensesFound: "Create",
        noExpensesFound: "Nessuna spesa trovata.",
        noDescription: "Nessuna descrizione",
        imagesCount: "Immagini ({count})",
        deleteImageTitle: "Elimina Immagine",
        deleteImageConfirm: "Sei sicuro di voler eliminare questa immagine? Questa azione non può essere annullata.",
        typeLabels: {
            fuel: "Carburante",
            car_wash: "Lavaggio",
            repairs: "Riparazioni",
            maintenance: "Manutenzione",
            parts: "Pezzi di Ricambio",
            insurance: "Assicurazione",
            inspection: "Ispezione",
            tyres: "Pneumatici",
            parking: "Parcheggio",
            electricity: "Elettricità",
            taxes: "Tasse",
            other: "Altro",
            info: "Informazioni",
            service_maintenance: "Manutenzione",
            service_repair: "Riparazione",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Servizio",
            selectSubtype: "Seleziona tipo di servizio",
            maintenance: "Manutenzione",
            repair: "Riparazione",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Spesa Ripetitiva",
        repeatToggle: "Ripeti questa spesa",
        repeatFrequency: "Frequenza",
        monthly: "Mensile",
        startDate: "Data di Inizio",
        nextDate: "La prossima voce sarà generata",
        endDate: "Data di Fine",
        noEndDate: "Nessuna data di fine",
        copyOptions: "Opzioni di Copia",
        copyTitle: "Copia titolo della registrazione",
        copyLocation: "Copia posizione",
        copyDescription: "Copia descrizione",
        active: "Attivo",
        status: "Stato",
        managedByRepeat: "Questa spesa fa parte di una sequenza ripetitiva.",
        placeholder: "Qui puoi impostare la ripetizione automatica per questa spesa se si verifica regolarmente con lo stesso importo.",
        deleteRepeat: "Elimina Ripetizione",
        deleteRepeatConfirm: "Sei sicuro di voler fermare ed eliminare questa sequenza ripetitiva? Le future voci non saranno generate. Le voci passate rimarranno.",
        relatedEntries: "Voci in questa sequenza",
        stopRepeat: "Ferma la ripetizione",
        isRepeating: "Ripetitivo",
        noTerm: "Indefinitamente",
        until: "L'ultima voce sarà generata",
        summaryCopy: "Il sistema copierà",
        simulate: "Simula la generazione della prossima voce",
        simulateSuccess: "Generazione della prossima voce simulata con successo",
        simulateNoDate: "Nessuna data disponibile per generare (data finale raggiunta)",
    },
    onboarding: {
        title: "Imposta Profilo",
        welcome: "Benvenuto!",
        subtitle: "Personalizza la tua esperienza di guida.",
        currency: "Valuta",
        preferredCurrency: "Valuta Preferita",
        distUnit: "Unità di Distanza",
        volUnit: "Unità di Volume",
        complete: "Completa Impostazione",
    },
    cars: {
        unitChangeWarningTitle: "Avviso di Cambio Unità",
        unitChangeWarningMessage: "Cambiare queste unità non convertirà i tuoi dati esistenti. Tutti i record storici rimarranno esattamente come inseriti.",
        unitChangeWarningConfirm: "Capito",
        title: "Garage",
        carAdmins: "Amministratori Auto",
        sharedWithMe: "Condiviso con Me",
        manageAdmins: "Gestisci Amministratori",
        adminEmail: "Email Amministratore",
        addAdmin: "Aggiungi Amministratore",
        addAdminPlaceholder: "es. amico@email.com",
        removeAdmin: "Rimuovi",
        removeAdminConfirm: "Sei sicuro di voler rimuovere questo amministratore?",
        adminAdded: "Amministratore aggiunto",
        adminRemoved: "Amministratore rimosso",
        removeMyAccess: "Rimuovi il mio accesso",
        removeMyAccessConfirm: "Sei sicuro di voler rinunciare all'accesso a quest'auto?",
        myAccessRemoved: "Accesso rimosso",
        noAdminsYet: "Nessun amministratore aggiunto ancora.",
        adminInfoText: "Gli amministratori possono aggiungere e modificare spese, note e pezzi di ricambio, ma non possono eliminare l'auto stessa.",
        newCar: "Aggiungi Auto",
        carNotFound: "Auto Non Trovata",
        carNotFoundDesc: "L'auto richiesta non esiste o non hai accesso.",
        accessDenied: "Accesso Negato",
        accessDeniedDesc: "Questa auto è privata e non disponibile pubblicamente.",
        backToHome: "Torna alla Home",
        adminRestricted: "Accesso Riservato",
        adminRestrictedDesc: "Solo gli amministratori autorizzati possono accedere a questa console. Torna all'applicazione principale.",
        returnHome: "Torna alla Home",
        editCar: "Modifica Auto",
        name: "Nome Auto",
        model: "Modello",
        year: "Anno",
        plate: "Numero di Targa",
        vin: "Numero VIN",
        mileage: "Chilometraggio Attuale",
        initialMileage: "Chilometraggio Iniziale",
        engineType: "Tipo di Motore",
        tapToChangeIcon: "Tocca per cambiare icona",
        chooseIcon: "Scegli Icona",
        imageTab: "Immagine",
        iconTab: "Icona",
        chooseColor: "Scegli Colore",
        chooseEmoji: "Scegli Emoji",
        uploadImage: "Carica Immagine",
        clickToBrowse: "Clicca per sfogliare i file",
        currentCarIcon: "Icona attuale dell'auto",
        changeImage: "Cambia Immagine",
        zoom: "Zoom",
        rotate: "Ruota",
        removeChangeImage: "Rimuovi / Cambia Immagine",
        selectIcon: "Seleziona Icona",
        cropAndSave: "Ritaglia & Salva",
        displayName: "Nome Visualizzato",
        displayNamePlaceholder: "es. La Mia Auto del Weekend",
        makeLabel: "Marca *",
        modelLabel: "Modello *",
        yearLabel: "Anno *",
        fuelTypeLabel: "Tipo *",
        licensePlateLabel: "Targa",
        vinLabel: "VIN",
        notesLabel: "Note",
        notesPlaceholder: "es. 1.6 TDI, 85kW, 1588cc, batteria 62kWh, AWD, ecc.",
        publicAccess: "Rendi l'auto pubblicamente accessibile",
        publicAccessDesc: "Altri possono visualizzare questa auto tramite link condiviso",
        shareLocations: "Consenti di visualizzare anche le posizioni aggiunte",
        shareLocationsDesc: "Abilita questo per rendere visibili le posizioni dell'auto in vista pubblica",
        deleteCar: "Elimina Auto",
        deleteCarTitle: "Elimina Auto",
        deleteCarConfirm: "Sei sicuro di voler eliminare '{name}'? Questa azione non può essere annullata.",
        noCars: "Nessuna auto nel tuo garage",
        addFirstCarNote: "Inizia il tuo viaggio aggiungendo il tuo primo veicolo per tenere traccia delle spese.",
        addVehicle: "Aggiungi Un Veicolo",
        myVehicles: "I Miei Veicoli",
        favorites: "Preferiti",
        deleteConfirm: "Sei sicuro di voler eliminare questa auto? Tutte le spese associate saranno eliminate.",
        deleteFailed: "Eliminazione dell'auto fallita",
        saveFailed: "Salvataggio dei dati dell'auto fallito",
        adminActions: "Azioni Amministrative",
        importCsv: "Importa CSV",
        clearData: "Cancella Dati",
        distanceUnitLabel: "Unità di Distanza",
        volumeUnitLabel: "Unità di Volume",
        currencyLabel: "Valuta",
        boughtAt: "Data di Acquisto",
        purchasePrice: "Prezzo di Acquisto",
        purchaseMileage: "Chilometraggio di Acquisto",
        createPurchaseRecord: "Crea automaticamente un record di storia di acquisto",
        makePlaceholder: "es. BMW",
        modelPlaceholder: "es. X5",
        platePlaceholder: "es. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Queste informazioni creeranno un record iniziale di 'Informazioni' nella tua storia con i dati specificati.",
        availableTypes: "Tipi Disponibili",
        dragToReorder: "Trascina per riordinare",
        requestTypeNote: "Se hai bisogno di un altro tipo - ",
        requestTypeAction: "faccelo sapere!",
        emailProcessingTitle: "Elaborazione Email",
        emailInstructions: "Inoltra le tue ricevute all'indirizzo qui sotto. Estrarremo i dati e creeremo automaticamente le spese.",
        recentEmails: "Email Ricevute",
        viewAllEmails: "VISUALIZZA TUTTE ({count})",
        noEmailsReceived: "Nessuna email ricevuta ancora.",
        analysisResult: "Risultato Analisi",
        vehicleInfo: "Informazioni sul Veicolo",
        preferences: "Preferenze",
        purchaseHistory: "Storia di Acquisto",
        emailProcessing: "Elaborazione Email",
        publicAccessTitle: "Accesso Pubblico",
        expenseTypesTitle: "Tipi di Spesa",
        adminActionsTitle: "Azioni Amministrative",
        enterPurchaseDateAlert: "Inserisci la data di acquisto",
        allowedSenderEmails: "Email Mittenti Consentiti",
        allowedEmailsDesc: "Aggiungi indirizzi email che sono autorizzati a inviare ricevute a questa auto. Massimo 5 indirizzi.",
        noAllowedEmails: "Nessuna email consentita aggiunta.",
        emailAlreadyAdded: "Questa email è già autorizzata per questa auto.",
        maxAllowedEmailsReached: "Limite massimo di email consentite raggiunto.",
        addAllowedEmailPlaceholder: "Aggiungi email consentita...",
        ownerEmail: "Proprietario",
        onlyOwner: "solo proprietario",
        defaultAllowed: "Sempre consentito",
        carLimitReachedTitle: "Limite Auto Raggiunto",
        carLimitReachedMessage: "Il tuo piano {plan} consente {limit} auto. Hai già {current}. Vai alle impostazioni per vedere i tuoi limiti o contattaci per un upgrade.",
        carLimitGoToSettings: "Vai alle Impostazioni",
        archivedCars: "Archiviato",
        archiveCar: "Archivia Auto",
        unarchiveCar: "Annulla Archiviazione Auto",
        sellDate: "Data di Vendita",
        sellPrice: "Prezzo di Vendita",
        sellMileage: "Chilometraggio di Vendita",
        archiveConfirm: "Sei sicuro di voler archiviare questa auto?",
        archiveInstructions: "Archiviare un'auto significa che non è più tua o che non la mantieni più. Si prega di fornire i dettagli di vendita per le statistiche. Questo renderà l'auto di sola lettura. I campi sottostanti possono comunque essere modificati in seguito.",
        archivedBadge: "Archiviato",
        saleDetails: "Dettagli di Vendita",
        saleDetailsNote: "I dettagli di vendita sono utilizzati per le statistiche. Puoi aggiornarli se necessario.",
        archiveDetailsNotFillable: "Si prega di compilare tutti i campi per archiviare l'auto",
        emailAddressWillBeAvailableAfterSave: "L'indirizzo email sarà disponibile dopo aver salvato l'auto.",
        proFeatureAdminTitle: "Funzione Pro: Amministratori dell'Auto",
        proFeatureAdminDesc: "Aggiungi altri utenti che possono visualizzare e gestire i dati di questa auto.",
        proFeatureEmailTitle: "Funzione Pro: Mittenti Aggiuntivi",
        proFeatureEmailDesc: "Aggiungi altri indirizzi email autorizzati da cui possono essere inviati i ricevute a questa auto.",
        estimatedMileage: "Chilometraggio stimato",
        summaryFrequencyLabel: "Frequenza Riepilogo",
        summaryFrequencyOptions: {
            none: "Disattivato",
            monthly: "Mensile",
            semiAnnually: "Semestrale",
            annually: "Annuale",
        },
        healthProfilePrompt: "Completa il tuo profilo di salute per un'analisi accurata!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Benzina",
        diesel: "Diesel",
        hybrid: "Ibrido",
        electric: "Elettrico",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Andamento del chilometraggio",
        title: "Statistiche",
        allYears: "Tutti gli anni",
        totalSpent: "Totale Speso",
        spentIn: "Speso nel {year}",
        perMonth: "al mese",
        overall: "globale",
        vsPrev12m: "vs 12m prec.",
        rolling12m: "12m mobili",
        byType: "Per Tipo",
        byMonth: "Per Mese",
        byYear: "Per Anno",
        noData: "Nessun dato per quest'anno",
        mostExpensive: "Più costoso",
        top: "Top",
        untitled: "Senza Titolo",
        assetAnalysis: "Analisi del Valore e dei Costi dell'Attivo",
        burnNote: "* Il 'Totale Bruciato' include sia il denaro speso che la diminuzione stimata del valore dell'auto.",
        carMarketValue: "Valore di Mercato dell'Auto",
        cumulativeCosts: "Costi Cumulativi",
        totalBurn: "Totale Bruciato (Costi + Deprezzamento)",
        entries: "voci",
        avgPrice: "Prezzo Medio",
        consumption: "Consumo",
        price: "Prezzo",
        fuelPriceTrend: "Andamento Prezzo Carburante",
        spendingTrend: "Tendenza di Spesa",
        costPerKmTrend: "Costo per 1 km",
        costPerMileTrend: "Costo per 1 miglio",
        serviceTrendsTitle: "Tendenze di Servizio",
        expensesOnMap: "Spese sulla Mappa",
        visitsCountLabel: "visite",
        locationsSummary: "Riepilogo Località",
        locationsCountLabel: "posti",
        noLocationsFoundTitle: "Nessuna località ancora",
        noLocationsFoundDesc: "Aggiungi località ai tuoi registri per vederle sulla mappa.",
        addMileageData: "Aggiungi chilometraggio",
        missingMileageInfo: "Non ci sono dati sufficienti per calcolare il costo per distanza. Aggiungi almeno 2 letture di chilometraggio in questo periodo (o una prima di questo periodo).",
        mileageModal: {
            title: "Aggiungi Chilometraggio Mancante",
            description: "Per calcolare accuratamente i costi per distanza per {year}, dobbiamo conoscere il chilometraggio all'inizio e alla fine dell'anno.",
            startOfYear: "Inizio anno (1 Gen)",
            endOfYear: "Fine anno (31 Dic)",
            currentMileage: "Chilometraggio attuale",
            placeholder: "Inserisci chilometraggio...",
            save: "Salva Dati",
            foundNearby: "Trovato nelle vicinanze ({date}): {value} {unit}",
            useExisting: "Usa questo",
        },
        proAnalysis: "Analisi Pro",
        detailedAnalysis: "Analisi Dettagliata",
        upgradeToSee: "Aggiorna per vedere →",
    },
    tabs: {
        dashboard: "Cruscotto",
        expenses: "Spese",
        stats: "Statistiche",
        locations: "Località",
        gallery: "File",
        parts: "Parti",
        notes: "Note",
        repair: "Modalità Riparazione",
        'repair-switch': "Interruttore Auto",
    },
    repairAnalysis: {
        title: "Analisi Decisione Riparazione",
        ownershipLength: "Durata di Proprietà",
        currentValue: "Valore Attuale",
        valueOutdated: "Il valore potrebbe essere obsoleto",
        addValueToEnable: "Aggiungi il valore attuale dell'auto per abilitare l'analisi",
        totalInvested: "Totale Investito",
        totalInvestedSub: "Prezzo di acquisto + riparazioni",
        totalExcludesFuel: "esclude carburante / elettricità",
        fuelLabelFuelOnly: "Totale carburante",
        fuelLabelEnergyOnly: "Totale energia",
        fuelLabelHybrid: "Totale carburante & energia",
        fuelTypeFuel: "carburante",
        fuelTypeEnergy: "elettricità",
        fuelTypeHybrid: "carburante & elettricità",
        fuelTotalLabel: "Totale Carburante/Energia:",
        projectionMode: "Modalità Proiezione",
        projectionModes: {
            lastYear: "Basato sull'anno scorso",
            average: "Media storica",
            trend: "Tendenza (lineare)",
        },
        brakeAssumption: "La manutenzione include un ciclo di freni stimato di 3 anni",
        repairBuffer: "Include un buffer di rischio di riparazione basato sull'età",
        yearLabel: "anno",
        totalInvestedDesc: "Prezzo di acquisto + tutte le riparazioni",
        repairToValue: "Riparare al Valore (12m)",
        repairToValueExplain: "Riparazioni €{cost} vs valore dell'auto €{value}. Sotto il 20% è sano; sopra il 50% è ad alto rischio.",
        ownershipPressure: "Pressione di Proprietà",
        ownershipPressureExplain: "Pressione totale dei costi: riparazioni €{cost} + perdita di valore vs €{value}. Sopra il 35% segnala stress finanziario.",
        investmentGap: "Gap di Investimento",
        investmentGapExplain: "Totale investito €{invested} meno valore attuale €{value}. Questo mostra quanto hai 'perso' sulla proprietà finora.",
        investmentGapDesc: "Totale investito - valore attuale",
        repairExpenses12m: "Costo Riparazione 12m",
        calculatedYearlyMileage: "Chilometraggio annuale calcolato: {km} km",
        calculatedYearlyRepairs: "Riparazioni annuali calcolate: {amount}",
        set: "Imposta",
        plannedRepairCost: "Costo di riparazione pianificato",
        whatIfTitle: "Cosa succede se spendi {amount} ora?",
        updatedScore: "Punteggio aggiornato",
        updatedVerdict: "Verdetto aggiornato",
        howIsItCalculated: "Come viene calcolato?",
        usedLifespan: "Utilizzato: {usage}% della vita utile prevista",
        remainingLifespan: "Rimanente: ~{km} km",
        estimatedLifespan: "Vita utile stimata: {km} km",
        lifecycle_stage_early: "Fase iniziale del ciclo di vita – basso rischio di guasti maggiori",
        lifecycle_stage_mid: "Fase intermedia del ciclo di vita – usura normale",
        lifecycle_stage_late: "Fase avanzata del ciclo di vita – aumento del rischio di riparazioni",
        lifecycle_stage_end: "Fine della vita utile prevista – alto rischio di riparazioni maggiori",
        calculationExplanation: "L'analisi utilizza il prezzo di acquisto del tuo veicolo, i costi di riparazione recenti e il valore attuale stimato per calcolare un punteggio di salute finanziaria. Costi di riparazione elevati rispetto al valore dell'auto o una rapida svalutazione abbasseranno il punteggio.",
        confidenceLabel: "Affidabilità",
        confidenceLevel: {
            high: "Alto",
            medium: "Medio",
            low: "Basso",
        },
        mentalFactorsTitle: "Migliora l'accuratezza con la tua esperienza",
        mentalFactorsCTA: "Controllo veloce (30 sec)",
        mentalFactorsSurveyTitle: "La Tua Esperienza",
        mentalFactorsSurveyDesc: "Rispondi a 3 domande rapide per personalizzare il tuo punteggio.",
        q1: "La tua auto soddisfa le tue esigenze?",
        q1Help: "Spazio, comfort, caratteristiche",
        q2: "Ti piace guidare la tua auto?",
        q2Help: "Aspetto, comfort, sensazione",
        q3: "Ti preoccupi di guasti imprevisti?",
        q3Help: "Preoccupazioni sulla affidabilità",
        q4: "Questa auto è per la famiglia e viaggi lunghi?",
        q4Help: "Priorità a sicurezza e affidabilità",
        factorsTitle: "Fattori di Punteggio",
        factorsDesc: "Scopri cosa influisce sul tuo punteggio",
        newCarComparison: "Confronto Auto Nuova",
        newCarComparisonDesc: "Confronta il tuo costo mensile attuale con l'acquisto di un'auto nuova.",
        modeLeasing: "Leasing",
        modeFullPrice: "Prezzo Intero",
        downPayment: "Anticipo",
        leaseYears: "Durata (Anni)",
        monthlyPayment: "Pagamento Mensile",
        carPrice: "Prezzo Completo dell'Auto",
        ownershipYears: "Proprietà Pianificata (Anni)",
        insuranceMonthly: "CASCO / Assicurazione Mensile",
        currentMonthlyCost: "Costo Auto Attuale",
        newCarMonthlyCost: "Costo Auto Nuova",
        newCarCheaper: "L'auto nuova è più economica di: {amount} / mese",
        newCarMoreExpensive: "L'auto nuova è più costosa di: {amount} / mese",
        newCarSameCost: "I costi sono esattamente gli stessi.",
        advancedSettings: "Impostazioni Avanzate",
        yearlyMaint: "Manutenzione Annuale (€)",
        tyres3Yrs: "Pneumatici / 3 anni (€)",
        depreciation5Yrs: "Ammortamento (5 anni %)",
        newCarYear: "Anno Auto Nuova",
        cumulativeCosts: "Costi Cumulativi (Proiezione)",
        comparisonByYear: "Confronto per Anno",
        currentCarLabel: "Auto Attuale",
        newCarLabel: "Auto Nuova",
        resaleValue: "Valore di Rivendita",
        startupCosts: "Costi di Avvio (Auto Usata)",
        inspection: "Ispezione pre-acquisto",
        initialMaintenance: "Manutenzione iniziale + oli",
        registration: "Registrazione / Spese",
        total: "Totale",
        currentCarTitle: "Auto Corrente",
        newCarTitle: "Auto Potenziale",
        upfrontInvestment: "Investimento Iniziale",
        monthlyReality: "Costo Mensile Reale",
        depreciationShort: "Ammortamento",
        howCalculated: "Come viene calcolato?",
        deltaMonthly: "Differenza Mensile",
        deltaUpfront: "Differenza Iniziale",
        surveyMeanings: {
            practical: {
                1: "Per niente",
                2: "Adatto scarso",
                3: "Nella media",
                4: "Buon adattamento",
                5: "Adattamento perfetto",
            },
            joy: {
                1: "Frustrante",
                2: "Noioso",
                3: "Nella media",
                4: "Piacevole",
                5: "Molto",
            },
            worry: {
                1: "Non preoccupato",
                2: "Leggermente preoccupato",
                3: "Preoccupato",
                4: "Molto preoccupato",
                5: "Sicuro che si romperà da un momento all'altro",
            },
        },
        verdicts: {
            KEEP: "Finanziariamente ragionevole mantenere",
            borderline: "Al limite – monitorare attentamente",
            sell: "Alto rischio finanziario – vendere può essere razionale",
        },
        factors: {
            trendInc: "Tendenza In Crescita",
            trendIncDesc: "I costi di riparazione stanno aumentando rispetto all'anno scorso.",
            lowDepreciation: "Vantaggio Basso Ammortamento",
            lowDepreciationDesc: "Auto più vecchie/economiche perdono meno valore nel tempo.",
            stableRepairs: "Riparazioni Stabili",
            stableRepairsDesc: "I tuoi costi di riparazione sono stabili o in diminuzione.",
            noHistoricalData: "Nessun dato più vecchio di 6 mesi.",
            lifecycle_stage: "Fase del ciclo di vita del veicolo",
            high_risk_phase: "Fase ad alto rischio",
            high_risk_phase_desc: "La combinazione di una fase avanzata del ciclo di vita e costi di riparazione in aumento indica un alto rischio.",
            lowCostKm: "Costo Efficiente per KM",
            lowCostKmDesc: "L'efficienza complessiva di gestione di quest'auto è eccellente.",
            lowFixedCosts: "Bassi Costi Fissi",
            lowFixedCostsDesc: "I tuoi costi fissi (tasse, assicurazione) sono bassi.",
            usage: "Utilizzo Annuale",
            usageDesc: "Distanza percorsa negli ultimi 12 mesi.",
            accidentMinor: "Incidente Minore",
            accidentMinorDesc: "Danni cosmetici o piccole riparazioni.",
            structuralDamage: "Danno Strutturale",
            structuralDamageDesc: "Problemi al telaio o strutturali riducono drasticamente il valore.",
            aiLifespanNearEnd: "Fine della Vita Utile Attesa",
            aiLifespanAging: "Componenti Invecchiati",
            aiLifespanGood: "Vantaggio Basso Chilometraggio",
            aiLifespanDesc: "Basato sulla vita utile tipica stimata dall'AI per questo modello.",
            aiUpcomingRepairs: "Riparazioni Imminenti (Previsione AI)",
            aiUpcomingRepairsDesc: "L'AI prevede guasti a componenti importanti a breve termine basandosi sul chilometraggio.",
            ownershipFatigue: "Affaticamento da Proprietà",
            ownershipFatigueLong: "La proprietà a lungo termine porta spesso a una prontezza mentale per un veicolo diverso.",
            ownershipFatigueShort: "Il bias iniziale di proprietà crea una tendenza più forte a mantenere l'auto.",
            family_priority: "Famiglia & Viaggi Lunghi",
            replacement_comparison: "Confronto Sostituzione",
            none: "Nessuno",
            surface: "Superficie",
            minor: "Minore",
            moderate: "Moderato",
            severe: "Severo",
            structural: "Strutturale",
            major: "Maggiore",
            critical: "Critico",
            full: "Completo",
            improveLabel: "Cosa migliorerebbe questo:",
            info_original_price: "Il prezzo approssimativo di questa auto quando era nuova. Aiuta a stimare la stabilità del valore. Le auto più vecchie con un valore residuo inferiore sono finanziariamente più sicure.",
            info_current_value: "Quanto potresti venderla oggi. Usato per controllare se le riparazioni sono una grande percentuale del valore dell'auto, il che segnala un cattivo investimento.",
            info_yearly_mileage: "Un chilometraggio più elevato aumenta l'usura. Un chilometraggio basso può estendere significativamente la vita dell'auto.",
            info_estimated_repairs: "Costo continuo per mantenere l'auto funzionante. Costi annuali elevati riducono l'attrattiva di mantenere l'auto.",
            info_planned_repairs: "Riparazioni imminenti conosciute. Simula una pressione immediata sulla tua decisione.",
            info_ownership_years: "Da quanto tempo possiedi quest'auto? Questo influisce sulla fatica psicologica di possesso e sul pregiudizio del compratore iniziale.",
            info_rust: "Rischio critico a lungo termine. La ruggine strutturale riduce la sicurezza. Ruggine severa rende la vendita un'opzione migliore.",
            info_crashes: "Incidenti strutturali influenzano la sicurezza e l'affidabilità. Riducono anche significativamente il valore di rivendita.",
            info_repaint: "Segnala danni passati o riparazioni cosmetiche. Impatto ridotto a meno che non siano stati nascosti problemi più profondi.",
            info_unresolved: "Costi futuri nascosti. Difetti noti in elettronica, motore o manutenzione che necessitano attenzione.",
            info_fit: "L'auto soddisfa le tue esigenze (spazio, comfort)? Un cattivo adattamento significa che è più probabile che tu la sostituisca.",
            info_joy: "Il valore emotivo conta. Nessuna gioia significa che sei mentalmente pronto per una nuova auto.",
            info_worry: "Stress percepito di affidabilità. Alta preoccupazione è un forte segnale per sostituire l'auto.",
        },
        explanations: {
            repairFreq: "La tua auto ha avuto {visits} visite di servizio negli ultimi 12 mesi. Visite frequenti indicano una minore affidabilità e maggiore disagio.",
            repairVsValue: "Negli ultimi 12 mesi, le tue riparazioni sono costate €{cost}, mentre il valore stimato dell'auto è di €{value}. Questo è il {ratio}% del valore totale dell'auto.",
            stableRepairsDetailYearly: "L'anno scorso hai speso €{cost1} in riparazioni, ma l'anno prima €{cost2}. Variazione di {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "Negli ultimi 6 mesi hai speso €{cost1}, nei 6 mesi precedenti €{cost2}. Variazione di {percent}% ({trend}).",
            mileage: "A {mileage} km, l'auto entra in una zona di rischio più elevato per guasti a parti importanti (trasmissione, componenti del motore).",
            planned: "Hai €{cost} in riparazioni pianificate, che riducono immediatamente la sicurezza finanziaria di mantenere l'auto.",
            lowDep: "Le auto valutate intorno a €{value} perdono molto poco valore all'anno, bilanciando costi di riparazione più elevati.",
            depRisk: "La tua auto ha {age} anni e ha quasi completato il suo ciclo di ammortamento, il che significa che non perdi denaro sul suo valore in calo.",
            stable: "Hai speso €{costThisYear} quest'anno rispetto a €{costLastYear} dell'anno scorso, il che rappresenta una diminuzione del {percent}%. I costi prevedibili sono matematicamente favorevoli.",
            costKm: "Hai percorso {km} km lo scorso anno. I costi di gestione erano di €{costKm} per chilometro, il che mostra un'eccellente efficienza economica.",
            fixedCosts: "Hai pagato €{costs} in costi fissi annuali (assicurazione/tassa). Questo basso impatto offre ulteriore tranquillità.",
            usage: "Guidi circa {km} km all'anno in base ai tuoi registri.",
            practical_fit: "Hai valutato l'adattamento pratico a {score}/5, modificando il punteggio matematico di {impact} punti.",
            emotional_satisfaction: "Hai valutato la tua soddisfazione emotiva a {score}/5, modificando il punteggio di {impact} punti.",
            reliability_anxiety: "La tua fiducia nell'affidabilità è di {score}/5, influenzando il punteggio di {impact} punti.",
            rust: "La ruggine strutturale o sotto il corpo grave significa tipicamente rischi per la sicurezza o scenari di rottamazione.",
            accident: "Danni precedenti, a seconda della gravità, riducono intrinsecamente il valore di rivendita e la sicurezza del veicolo.",
            structural: "I problemi strutturali rendono automaticamente l'auto finanziariamente pericolosa.",
            ai_lifespan: "A {current} km, l'auto ha completato il {ratio}% della sua vita utile stimata dall'AI ({expect} km).",
            ai_repairs: "I dati dell'AI indicano che si tendono a verificare {count} riparazioni principali tipiche specifiche del modello a questo chilometraggio.",
            lifecycle_stage: "Cosa significa vita utile? {total} km – questo è il punto previsto dall'AI in cui iniziano tipicamente le riparazioni strutturali principali (motore, cambio, ecc.) per questo modello. Non è la fine della vita dell'auto – l'auto può ancora guidare, ma con costi di manutenzione significativamente più elevati. La vita fisica totale di un'auto tipica è di 500k–1M km, ma diventa economicamente non sostenibile molto prima.",
        },
        ratios: {
            healthy: "Sano",
            monitor: "Monitorare",
            highRisk: "Alto rischio",
            stable: "Stabile",
            warning: "Attenzione",
            financialStress: "Stress finanziario",
        },
        proFeatureTitle: "Funzione Pro: Modalità Riparazione",
        proFeatureDesc: "Sblocca il motore decisionale per ottenere un'analisi finanziaria professionale delle riparazioni del tuo veicolo. Gli utenti gratuiti vedono una dimostrazione con dati di esempio.",
        viewDemo: "Guarda la Demo Live",
        upgradeToUnlock: "Aggiorna a PRO per analizzare la tua auto",
    },
    carTasks: {
        title: "Compiti dell'Auto",
        placeholderTitle: "Monitoraggio Manutenzione",
        placeholderDesc: "Piano di manutenzione per il tuo modello di auto.",
        demoTitle: "Compiti di Manutenzione dell'Auto",
        demoSubtitle: "Monitoraggio intelligente per il tuo veicolo",
        feature1Title: "Generazione Automatica di Compiti",
        feature1Desc: "Genera automaticamente compiti come cambi d'olio, sostituzioni di filtri e controlli della cinghia di distribuzione in base al modello della tua auto.",
        feature2Title: "Integrazione delle Spese",
        feature2Desc: "Analizza la tua cronologia di servizio per capire cosa è già stato fatto e quando.",
        feature3Title: "Promemoria Intelligenti",
        feature3Desc: "Ricevi notifiche in base sia al tempo che al chilometraggio. Il monitoraggio si resetta automaticamente quando segni un compito come completato.",
        getStarted: "Inizia",
        fakeDoorPopupTitle: "Feedback Benvenuto",
        fakeDoorPopupMessage: "Stiamo attualmente sviluppando compiti di manutenzione per auto. Questa funzione ti permetterà di monitorare automaticamente gli intervalli di servizio. Quali compiti o funzioni specifiche vorresti vedere di più?",
        fakeDoorPopupPlaceholder: "I tuoi pensieri...",
        noTasksYet: "Nessun compito ancora",
        deleteAllTitle: "Cancellare la lista delle attività?",
        deleteAllMessage: "Sei sicuro di voler eliminare tutte le {count} attività per questa auto? Questa azione non può essere annullata.",
        deleteAllSuccess: "Tutte le attività sono state eliminate con successo.",
        sortPriority: "Priorità",
        sortType: "Tipo",
        sortDate: "Ultimo",
        status: {
            overdue: "SCADUTO",
            pending: "PENDENTE",
            noData: "NESSUN DATO",
            upcoming: "In arrivo",
            nextIn: "Prossimo in {dist} {unit}",
            overdueBy: "{dist} {unit} scaduto",
            afterDays: "Tra {days} giorni",
            overdueDays: "{days} giorni scaduti",
        },
        form: {
            newTitle: "Nuova Attività",
            actionType: "Ispezionare o Sostituire?",
            intervalMonths: "Intervallo (Mesi)",
            intervalDistance: "Intervallo (Distanza)",
            diffFirstInterval: "Il primo intervallo differisce dall'intervallo base",
            firstInterval: "Primo Intervallo",
            historyToggle: "Questa attività è mai stata eseguita per questa auto?",
            historyToggleDesc: "Se NO, assumiamo che non sia mai stata fatta dalla produzione.",
            lastPerformedOptional: "Quando è stata eseguita l'ultima volta? (Opzionale)",
            deleteTitle: "Elimina Attività",
            deleteConfirm: "Sei sicuro di voler eliminare questa attività?",
            saveError: "Impossibile salvare l'attività",
            historyConfirmed: "Storico Confermato",
            reminders: "Promemoria",
            notifyMileage: "Avvisami quando viene raggiunta la percorrenza stimata",
            notifyDate: "Avvisami quando viene raggiunta la data",
            nextMileageReminder: "Data stimata",
            nextDateReminder: "Data di scadenza",
            estimatedDate: "Data stimata",
            missingLastMileage: "Chilometraggio dell'ultima manutenzione mancante",
            missingLastDate: "Data dell'ultima manutenzione mancante",
            missingStartDate: "Impossibile determinare la data di inizio",
            additionalOptions: "Opzioni aggiuntive",
            reminderInfoMissing: "Stato informativo: i promemoria sono disabilitati fino a quando non vengono forniti i dati dell'ultima esecuzione.",
        },
    },
    dashboard: {
        title: "Dashboard",
        quickActions: "Azioni Veloci",
        addExpense: "Aggiungi Spesa",
        editCar: "Modifica Auto",
        recentExpenses: "Spese",
        seeAll: "Vedi Tutto",
        recentGallery: "File",
        thisMonth: "Questo Mese",
        totalSpent: "Totale Speso",
        avgPerMonth: "Media/Mese",
        recentNotes: "Note",
        recentParts: "Parti",
        noRecentExpenses: "Nessuna spesa recente",
        noRecentGallery: "Nessuna foto recente",
        noRecentNotes: "Nessuna nota recente",
        noRecentParts: "Nessuna parte recente",
        createNote: "Crea Nuova",
        createPart: "Crea Nuova",
        createExpense: "Crea Nuova",
        noFiles: "Nessun file aggiunto ancora",
        needSomethingMore: "Hai bisogno di qualcosa di più?",
        letUsKnow: "faccelo sapere!",
    },
    expenseTypes: {
        editTitle: "Modifica Tipo di Spesa",
        newTitle: "Nuovo Tipo di Spesa",
        categoryName: "Nome Categoria",
        placeholderName: "es. Servizio",
        signatureColor: "Colore Firma",
        icon: "Icona Categoria",
        deleteConfirm: "Sei sicuro di voler eliminare il tipo '{name}'?",
    },
    spareParts: {
        title: "Parti di Ricambio",
        connectedWithRecords: "Collegato con i Registri",
        toBuy: "Da Comprare",
        usedInExpenses: "Utilizzate nelle Spese",
        noPartsToBuy: "Nessuna parte aggiunta alla lista della spesa",
        noPartsUsed: "Nessuna parte collegata alle spese ancora",
        quantity: "Qtà",
        partCode: "Codice Parte",
        price: "Prezzo",
        link: "Collegamento",
        comment: "Commento",
        addPart: "Aggiungi Parte di Ricambio",
        editPart: "Modifica Parte di Ricambio",
        openPart: "Apri voce parte",
        nameLabel: "Nome",
        manufacturerLabel: "Produttore",
        priceLabel: "Prezzo ({currency})",
        imagesLabel: "File",
        linkedHistory: "Storia Collegata",
        partManagedNote: "Questa parte è gestita tramite una spesa",
        cannotDeleteNote: "Poiché questa parte è collegata a una spesa, non può essere eliminata separatamente. Elimina o modifica la spesa per gestire il ciclo di vita di questa parte.",
        partNamePlaceholder: "Nome della parte...",
        manufacturerPlaceholder: "Bosch, Brembo, ecc.",
        additionalInfoPlaceholder: "Informazioni aggiuntive...",
        namePlaceholder: "es. Pastiglie dei freni",
        codePlaceholder: "es. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Salva Parte",
        deletePart: "Elimina parte di ricambio",
        deleteConfirm: "Sei sicuro di voler eliminare questa parte di ricambio?",
        sparePartsLabel: "Parti di Ricambio",
        partNumber: "Parte #{number}",
        imagesLimitLabel: "File (fino a 5)",
        optional: "(opzionale)",
        selectPart: "Seleziona Parte di Ricambio",
        createNew: "Crea nuova parte di ricambio",
        searchPlaceholder: "Cerca per nome o codice...",
        noResults: "Nessuna parte trovata",
        noPartsYet: "Nessuna parte ancora. Crea la tua prima!",
        selectorDescription: "Trova e seleziona una parte di ricambio esistente, o creane una nuova",
        alreadyAdded: "Questo pezzo è già stato aggiunto",
        statistics: {
            avgPrice: "Media",
            lastPrice: "Ultimo",
            usedTimes: "Utilizzata {count} volte",
            totalPurchased: "Totale: {quantity}x",
        },
        usage: {
            title: "Questo Acquisto",
            quantity: "Quantità",
            pricePerUnit: "Prezzo per unità",
            comment: "Commento",
            commentPlaceholder: "es., Comprato da AutoZone",
            total: "Totale",
            transactionData: "Questa Transazione",
        },
        masterData: "Informazioni Principali sul Pezzo",
        masterRecord: {
            title: "Dettagli Parte (condivisi)",
            editMaster: "Modifica Record Master",
            warning: "Le modifiche al record master influenzano tutti gli utilizzi",
        },
    },
    reminders: {
        title: "Promemoria",
        reminder: "Promemoria",
        noteReminder: "Promemoria Nota",
        partReminder: "Promemoria Parte",
        today: "Oggi",
        tomorrow: "Domani",
        yesterday: "Ieri",
        inXDays: "in {x} giorni",
        xDaysAgo: "{x} giorni fa",
        inXMonths: "in {x} mesi",
        xMonthsAgo: "{x} mesi fa",
        active: "Attivo",
        activeDesc: "Se necessario, puoi disattivare questo promemoria senza eliminarlo",
        disabled: "Disabilitato",
        yearly: "Annuale",
        markSeen: "Riconosci",
        addReminder: "Nuovo Promemoria",
        editReminder: "Modifica Promemoria",
        extraReminders: "Promemoria Extra",
        extraRemindersDesc: "Invia 3 promemoria aggiuntivi nei giorni seguenti (4 in totale) se non fermato.",
        remindDate: "Data",
        remindTime: "Ora",
        repeatYearly: "Ripeti Annualmente",
        repeatYearlyDesc: "Questo promemoria si verificherà automaticamente ogni anno nella stessa data/mese/giorno/ora fino a quando non verrà disabilitato",
        standalone: "Promemoria Standalone",
        embedded: "Promemoria Collegati",
        noReminders: "Nessun promemoria attivo",
        deleteReminder: "Elimina Promemoria",
        nameLabel: "Nome",
        descriptionLabel: "Descrizione",
        namePlaceholder: "Nome del promemoria",
        descriptionPlaceholder: "Breve descrizione o nota",
        simulateReminder: "Simula momento del promemoria",
        simulateSuccess: "Email di simulazione inviata",
        timezone: "Fuso orario",
        nextReminder: "Prossimo promemoria",
        futureTimeError: "L'orario del promemoria deve essere nel futuro",
    },
    notes: {
        title: "Note",
        emptyNote: "Nota vuota",
        noNotes: "Nessuna nota ancora",
        addNote: "Aggiungi Nota",
        editNote: "Modifica Nota",
        viewNote: "Visualizza Nota",
        openNote: "Apri voce nota",
        titleLabel: "Titolo",
        contentLabel: "Contenuto",
        noteTitlePlaceholder: "Titolo della nota...",
        noteContentPlaceholder: "Scrivi la tua nota qui...",
        saveNote: "Salva Nota",
        deleteNote: "Elimina Nota",
        publicNote: "Rendi la nota pubblica",
        publicNoteDesc: "Altri possono visualizzare questa nota tramite il link condiviso",
        deleteConfirm: "Sei sicuro di voler eliminare questa nota?",
        enterTitleAlert: "Per favore inserisci un titolo",
        saveFailed: "Salvataggio della nota fallito",
        thisNote: "Questa nota",
        deleteFailed: "Eliminazione della nota fallita",
        pinToTop: "Fissa in alto",
    },
    locations: {
        title: "Località",
        singleTitle: "Località",
        newLocation: "Nuova Località",
        emptyLocation: "Località vuota",
        noLocations: "Per le statistiche - puoi aggiungere la località in cui è avvenuto questo costo per auto",
        addLocation: "Aggiungi Località",
        editLocation: "Modifica Località",
        viewLocation: "Visualizza Località",
        openLocation: "Apri Località",
        createNew: "Crea nuova località",
        selectLocation: "Seleziona località",
        searchLocations: "Cerca località...",
        nameLabel: "Nome",
        addressLabel: "Indirizzo o Coordinate",
        descriptionLabel: "Commento/Descrizione",
        namePlaceholder: "es. Servizio Centro",
        mapLabel: "Località",
        searchPlaceholder: "Cerca indirizzo...",
        addressPlaceholder: "Inserisci indirizzo e seleziona...",
        descriptionPlaceholder: "Informazioni aggiuntive...",
        fillAddress: "Compila indirizzo dalla mappa",
        saveLocation: "Salva Località",
        deleteLocation: "Elimina località",
        deleteConfirm: "Sei sicuro di voler eliminare questa località?",
        enterNameAlert: "Per favore inserisci un nome",
        saveFailed: "Salvataggio della località fallito",
        thisLocation: "Questa località",
        deleteFailed: "Eliminazione della località fallita",
        myLocations: "Le Mie Località",
        usedInEntries: "Utilizzato nelle voci",
        noEntries: "La località non è utilizzata",
        noEntriesThisCar: "Questa località non è stata utilizzata per questa auto",
        removeLocation: "Rimuovi località",
        noResults: "Nessun risultato trovato",
    },
    gallery: {
        title: "File",
        noImages: "Nessuna immagine aggiunta",
        addImagesNote: "Aggiungi immagini all'auto o alle spese",
        totalImages: "Totale {count} immagini",
        imageAlt: "Immagine {number}",
        commentPlaceholder: "Commento sul file",
        isReceipt: "Questo file è una ricevuta",
        deleteImageTitle: "Elimina file",
        deleteImageConfirm: "Sei sicuro di voler eliminare permanentemente questo file?",
    },
    search: {
        placeholder: "Cerca spese, parti, note...",
        typeToSearch: "Digita per iniziare la ricerca",
        noResults: "Nessun risultato trovato per '{query}'",
        carImage: "Immagine dell'auto",
        expenseImage: "Immagine della spesa",
        noteImage: "Immagine della nota",
        galleryImage: "Immagine della galleria",
        untitledExpense: "Spesa senza titolo",
    },
    landing: {
        nav: {
            features: "Funzionalità",
            howItWorks: "Come funziona",
            pricing: "Prezzi",
            login: "Accedi",
            getStarted: "Inizia",
            garage: "Garage",
        },
        hero: {
            title: "Scopri Esattamente Quanto Costa La Tua Auto",
            subtitle: "Davvero",
            description: "Monitora le spese, registra le riparazioni e vedi dove va davvero il tuo denaro.",
            subheadline: "Il dashboard professionale basato sui dati per i proprietari di auto meticolosi.",
            startTracking: "Inizia",
            viewDemo: "Demo Auto ->",
            trustSignal: "Unisciti a oltre 1.200 proprietari meticolosi che hanno già mappato oltre 5 milioni di chilometri di costi reali per auto.",
            ctaNote: "Nessuna carta di credito. Nessuna vendita aggressiva. Solo chiarezza.",
            benefits: {
                repairVsSell: {
                    title: `Riparare vs. Vendere`,
                    description: `Identifica la soglia "Riparare vs. Vendere" — Smetti di chiederti se stai buttando soldi in un pozzo senza fondo. Conosci il momento esatto in cui una riparazione non è più un investimento intelligente.`
                },
                costPerKm: {
                    title: `Costo per KM`,
                    description: `Monitora il tuo costo reale per chilometro — Vai oltre il dashboard. Vedi l'intera situazione finanziaria delle tue abitudini di guida che altre app trascurano.`
                },
                automation: {
                    title: `Automazione`,
                    description: `Automatizza la tua registrazione — Inoltra semplicemente le tue fatture o invia le tue note via email. La nostra IA organizza per te la storia tecnica della tua auto.`
                }
            },
        },
        features: {
            title: "Tutto ciò di cui hai bisogno per gestire la tua auto",
            subtitle: "Smetti di usare fogli di calcolo e cartelle disordinate. My Car Costs porta strumenti professionali di gestione della flotta nel tuo garage personale.",
            expenseTracking: {
                title: "Tracciamento delle Spese",
                description: "Registra carburante, servizio, assicurazione e riparazioni. Categorizza i costi e visualizza le tendenze di spesa nel tempo.",
            },
            spareParts: {
                title: "Gestore di Parti di Ricambio",
                description: "Mantieni un inventario dettagliato di parti di ricambio, numeri di parte e note di compatibilità per tutte le tue riparazioni.",
            },
            serviceHistory: {
                title: "Storico Servizi & Note",
                description: "Mantieni un libretto di servizio digitale. Aggiungi note dettagliate su manutenzione, modifiche o piani futuri.",
            },
            documentStorage: {
                title: "Archiviazione Documenti",
                description: "Carica ricevute, fatture e foto della tua auto. Tieni al sicuro e accessibili tutti i tuoi documenti.",
            },
            emailForwarding: {
                title: "Inoltro Email",
                description: "Inoltra le fatture direttamente alla tua casella di posta unica. Estrarremo i dati e li aggiungeremo automaticamente al tuo cruscotto.",
            },
            multiCar: {
                title: "Garage Multi-Auto",
                description: "Gestisci un'auto o un'intera flotta. Passa istantaneamente tra i veicoli e visualizza statistiche aggregate.",
            },
            repeatingExpenses: {
                title: "Spese Ripetitive",
                description: "Automatizza il monitoraggio dei costi mensili regolari come assicurazione, parcheggio o leasing.",
            },
            smartReminders: {
                title: "Promemoria Intelligenti",
                description: "Imposta avvisi personalizzati per pezzi di ricambio e note di servizio per non perdere mai un compito di manutenzione.",
            },
        },
        howItWorks: {
            title: "Flusso di lavoro semplice e potente",
            step1: {
                title: "Aggiungi il tuo veicolo",
                description: "Inserisci i dettagli della tua auto per creare il tuo garage digitale.",
            },
            step2: {
                title: "Registra spese e file",
                description: "Scatta una foto di una ricevuta o inoltra un'email. Ci occupiamo del resto.",
            },
            step3: {
                title: "Ottieni informazioni",
                description: "Visualizza il tuo costo per chilometro, le spese mensili e la cronologia della manutenzione.",
            },
        },
        useCases: {
            title: "Perfetto per",
            enthusiasts: {
                title: "Appassionati di Auto",
                description: "Traccia ogni modifica, numero di parte e intervallo di manutenzione per la tua auto da progetto.",
            },
            dailyDrivers: {
                title: "Guidatori Quotidiani",
                description: "Sappi esattamente quanto costa il tuo tragitto e non perdere mai una data di servizio.",
            },
            flippers: {
                title: "Il Flipper Intelligente",
                description: "Costruisci un volume verificabile di dati che dimostrano il vero valore della tua auto per gli acquirenti.",
            },
            fleets: {
                title: "Piccole Flotte",
                description: "Gestisci più veicoli aziendali in un unico posto senza il peso del software enterprise.",
            },
        },
        foundersNote: {
            title: "Nota del Fondatore",
            content: "Sto costruendo MyCarCosts per essere lo strumento definitivo per le persone che si prendono davvero cura delle loro auto. C'è una funzionalità mancante nel tuo flusso di lavoro? Contattami direttamente. Se ha senso per la comunità, la costruiremo insieme.",
        },
        pricing: {
            freeLimitedTime: "Gratis per un tempo limitato",
            title: "Prezzi semplici e trasparenti",
            subtitle: "Inizia gratuitamente, aggiorna man mano che cresci.",
            perMonth: "mese",
            monthly: "Mensile",
            yearly: "Annuale",
            save25: "Risparmia il 25%",
            billedAnnually: "Fatturato annualmente ({amount})",
            free: {
                title: "Gratuito",
                cta: "Inizia",
            },
            pro: {
                title: "Pro",
                cta: "Aggiorna a Pro",
                recommended: "Consigliato",
                earlyAdopter: "Prezzo per early adopter",
                priceLock: "Blocca questo prezzo ora. Il prezzo potrebbe aumentare in futuro.",
            },
            custom: {
                title: "Custom",
                cta: "Contattaci",
            },
            features: {
                oneCar: "1 auto",
                unlimitedExpenses: "Spese illimitate",
                unlimitedSpareParts: "Ricambi illimitati",
                unlimitedNotes: "Note illimitate",
                repeatedExpenses: "Spese ripetute",
                emailReminders: "Promemoria via email per note e ricambi",
                basicStatistics: "Statistiche di base",
                fullStatistics: "Statistiche complete",
                storage50mb: "50 Mb di spazio di archiviazione",
                unlimitedArchivedCars: "Auto archiviate illimitate",
                dataExport: "Esportazione dati",
                allInFreePlus: "tutto incluso free plus:",
                threeCars: "Fino a 3 auto",
                storage2gb: "2 Gb di spazio di archiviazione",
                emailParsing: "Parsing delle email",
                carAdmins: "Amministratori dell'auto",
                moreCars: "Più auto",
                moreFileStorage: "Maggiore spazio di archiviazione",
                customRequirements: "Requisiti personalizzati",
            },
            upgradePopup: {
                title: "In Arrivo!",
                message: "Le versioni pro e personalizzate non sono ancora state lanciate, ma lo saranno presto. Per aiutarci a lanciare più velocemente - ti preghiamo di scrivere quale funzionalità specifica ti aspetti dalla versione pro / personalizzata, o qualsiasi altra cosa che vorresti che migliorassimo per rendere questa piattaforma ancora migliore per te!",
                placeholder: "Scrivi il tuo feedback qui...",
                submit: "Invia",
                cancel: "Annulla",
                thanksTitle: "Grazie!",
                thanksMessage: "Abbiamo ricevuto il tuo feedback e lavoreremo per rendere MyCarCosts ancora migliore!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Passi da Excel o un'altra app?",
            subtitle: "Offriamo un servizio professionale di migrazione dei dati per farti partire immediatamente.",
            pricingModel: "Modello di prezzo",
            small: {
                title: "Piccolo dataset",
                description: "< 500 righe",
                price: "$19–29",
            },
            medium: {
                title: "Dataset medio",
                description: "500–5.000 righe",
                price: "$49",
            },
            large: {
                title: "Grande / Disordinato",
                description: "Sistemi legacy o file complessi",
                price: "Preventivo personalizzato",
            },
            process: {
                title: "Come funziona",
                step1: "Invii il tuo file",
                step2: "Valutiamo i dati",
                step3: "Pagamento una tantum",
                step4: "Ci occupiamo dell'importazione",
            },
            cta: "Richiedi Migrazione",
        },
        repairAnalysisSection: {
            title: "Riparare o vendere? Lascia che siano i dati a decidere.",
            subtitle: "Analisi finanziaria professionale per il tuo veicolo. Smetti di indovinare e inizia a sapere se quelle riparazioni valgono davvero la pena.",
            features: {
                personalized: {
                    title: "Analisi Personalizzata",
                    description: "Per le tue auto tracciate, utilizziamo spese e parametri storici reali, aggiungendo costi pianificati per generare una valutazione.",
                },
                public: {
                    title: "Simulatori Pubblico",
                    description: "Stai valutando un acquisto potenziale? Usa il nostro strumento pubblico su /repair per generare un'analisi dettagliata inserendo solo pochi dettagli chiave.",
                },
                whatIf: {
                    title: "Simulatore What-If",
                    description: "Inserisci un costo di riparazione pianificato e vedi immediatamente come influisce sul punteggio finanziario della tua auto.",
                },
            },
            cta: "Visualizza Analisi Esempio",
        },
        faq: {
            title: "Domande Frequenti",
            subtitle: "Tutto ciò che devi sapere su My Car Costs",
            questions: {
                mobileApps: {
                    question: "Ci saranno app per iOS e Android?",
                    answer: "Sì! Le app mobili per iOS e Android arriveranno presto. Stiamo lavorando duramente per offrirti la migliore esperienza mobile.",
                },
                dataPrivacy: {
                    question: "I miei dati sono privati e sicuri?",
                    answer: "Assolutamente. I tuoi dati sono crittografati e archiviati in modo sicuro. Solo tu puoi accedere alle informazioni della tua auto, a meno che tu non scelga esplicitamente di renderle pubbliche.",
                },
                freePlan: {
                    question: "Il piano gratuito è davvero gratuito per sempre?",
                    answer: "Sì! Il piano gratuito sarà sempre disponibile con un'auto e tutte le funzionalità essenziali. Puoi passare a Pro in qualsiasi momento per fino a 3 auto e funzionalità avanzate.",
                },
                dataExport: {
                    question: "Posso esportare i miei dati?",
                    answer: "Sì, puoi esportare tutti i tuoi dati in qualsiasi momento in formato CSV o PDF. I tuoi dati sono tuoi e non sei mai bloccato.",
                },
                emailImport: {
                    question: "Come funziona l'importazione email?",
                    answer: "Ogni auto ha un indirizzo email unico. Basta inoltrare le tue fatture e noi estrarremo i dati automaticamente.",
                },
                multipleUsers: {
                    question: "Possono più persone accedere alla stessa auto?",
                    answer: "Attualmente, ogni auto appartiene a un solo account. Tuttavia, puoi rendere un'auto visibile pubblicamente per condividere l'accesso in sola lettura con altri.",
                },
            },
        },
        cta: {
            title: "Smetti di indovinare. Inizia a sapere.",
            subtitle: "Trasforma la cronologia della tua auto in chiare decisioni finanziarie. Unisciti a migliaia di proprietari esperti che sanno esattamente quando investire o vendere.",
            button: "Inizia ora",
            note: "Nessuna carta di credito. Nessuna vendita aggressiva. Solo chiarezza.",
        },
        footer: {
            product: "Prodotto",
            legal: "Legale",
            changelog: "Registro delle modifiche",
            privacy: "Informativa sulla privacy",
            contact: "Contatto",
            contactEmail: "info@mycarcosts.com",
            questions: "Hai domande? Contattaci a:",
        },
        privacy: {
            title: "Informativa sulla privacy",
            lastUpdated: "Ultimo aggiornamento: 25 marzo 2026",
            introduction: "In My Car Costs, prendiamo sul serio la tua privacy. Questa informativa spiega come gestiamo i tuoi dati.",
            dataCollection: {
                title: "Raccolta Dati",
                description: "Raccogliamo solo il minimo assoluto di informazioni necessarie per fornire il nostro servizio.",
                email: "Identità dell'Account: Utilizziamo il tuo indirizzo email come identificatore unico e per l'autenticazione (ad es., link magici o accesso Google).",
                documents: "Archiviazione Documenti: I file che carichi sono archiviati in modo sicuro in un'archiviazione cloud crittografata.",
            },
            carData: {
                title: "Controllo dei Tuoi Dati",
                description: "Le informazioni che inserisci (spese, chilometraggio, parti) sono archiviate per il tuo uso personale e analisi.",
                noValidation: "Non convalidiamo i dati dell'auto che fornisci; è tua responsabilità garantire l'accuratezza.",
                privateByDefault: "Per impostazione predefinita, i tuoi dati sono privati. Gli identificatori tecnici per i file non sono sequenziali e non sono indicizzati dai motori di ricerca.",
                rightToForgotten: "Diritto all'Oblio: Puoi eliminare il tuo account in qualsiasi momento, il che rimuove immediatamente e permanentemente tutti i tuoi record e file.",
            },
            thirdParty: {
                title: "Servizi di terze parti",
                description: "Non vendiamo i tuoi dati personali. Quando utilizzi il login di Google, accediamo solo al tuo indirizzo email per scopi di identificazione.",
            },
            emailIngestion: {
                title: "Acquisizione email",
                description: "Le email inviate al nostro servizio di acquisizione vengono archiviate per fornire una cronologia di elaborazione. Puoi eliminare manualmente singole email o l'intera cronologia in qualsiasi momento.",
            },
        },
        emails: {
            deleteAll: "Elimina tutto",
            deleteAllConfirm: "Sei sicuro di voler eliminare tutta la cronologia delle email per questa auto? Questa azione è irreversibile.",
            deleteConfirm: "Sei sicuro di voler eliminare questa email?",
            noEmails: "Nessuna email ricevuta finora.",
        },
        terms: {
            title: "Termini e Condizioni",
            lastUpdated: "Ultimo aggiornamento: 25 marzo 2026",
            introduction: "Accedendo o utilizzando MyCarCosts, accetti di essere vincolato da questi Termini e Condizioni. Se non accetti, ti preghiamo di non utilizzare il nostro servizio.",
            acceptance: {
                title: "1. Accettazione dei termini",
                description: "Questi termini costituiscono un accordo legalmente vincolante tra te e MyCarCosts riguardante l'uso della nostra applicazione e dei nostri servizi.",
            },
            service: {
                title: "2. Descrizione del servizio",
                description: "MyCarCosts fornisce una piattaforma per il monitoraggio delle spese dei veicoli, la gestione della manutenzione e l'analisi finanziaria. Ciò include l'analisi delle ricevute tramite AI e strumenti di visualizzazione dei dati.",
            },
            responsibilities: {
                title: "3. Responsabilità dell'utente",
                description: "Sei responsabile dell'accuratezza di tutti i dati inseriti, inclusi chilometraggio, numeri VIN e costi. Devi mantenere al sicuro le tue credenziali di accesso (email/magic link) e non condividerle con terze parti non autorizzate.",
            },
            plans: {
                title: "4. Piani di servizio e limiti",
                description: "Offriamo piani Free e Pro con diversi limiti di archiviazione, numero di auto e caricamento. Ci riserviamo il diritto di modificare questi limiti o introdurre nuovi livelli di abbonamento in qualsiasi momento.",
            },
            disclaimer: {
                title: "5. Esclusioni di responsabilità e accuratezza",
                description: "MyCarCosts è uno strumento di informazione e organizzazione. Non forniamo certificazioni ufficiali sullo stato del veicolo. I dati estratti dalle ricevute tramite AI devono sempre essere verificati dall'utente per verificarne l'accuratezza.",
            },
            liability: {
                title: "6. Limitazione di responsabilità",
                description: "MyCarCosts viene fornito 'così com'è'. Non siamo responsabili per eventuali problemi meccanici, perdite finanziarie o inesattezze dei dati derivanti dall'uso della nostra applicazione.",
            },
            termination: {
                title: "7. Risoluzione",
                description: "Puoi interrompere l'uso del servizio ed eliminare i tuoi dati in qualsiasi momento. Ci riserviamo il diritto di sospendere o chiudere gli account che violano questi termini o adottano comportamenti abusivi.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

